import { AxiosError, AxiosResponse } from 'axios'

import createAccessProfile from './access-profile/create-access-profile'
import deleteGroupUser from './access-profile/delete-group-user'
import getGroupUsersDetails from './access-profile/get-group-users-details'
import listGroupUserProfiles from './access-profile/list-group-user-profiles'
import listGroupUsers from './access-profile/list-group-users'
import listGroupUsersByFeedGroup from './access-profile/list-group-users-by-feed-group'
import listManagerGroupUsers from './access-profile/list-manager-group-users'
import listNonAdminGroupUsers from './access-profile/list-non-admin-group-users'
import updateGroupPermissions from './access-profile/update-group-permissions'
import updateGroupUsersName from './access-profile/update-group-users'
import changePassword from './auth/change-password'
import createMacroArea from './body-inspection/create-macro-area'
import createPoint from './body-inspection/create-point'
import deleteMacroArea from './body-inspection/delete-macro-area'
import deletePoint from './body-inspection/delete-point'
import getMacroAreas from './body-inspection/get-macro-areas'
import getPoints from './body-inspection/get-points'
import updateMacroArea from './body-inspection/update-macro-area'
import updatePoint from './body-inspection/update-point'
import belongConfig from './client-config/config-belong'
import bodyConfig from './client-config/config-body'
import caaConfig from './client-config/config-caa'
import getBelongConfig from './client-config/get-config-belong'
import getBodyConfig from './client-config/get-config-body'
import getCAAConfig from './client-config/get-config-caa'
import blockOperatorAccessById from './clinic/block-operator-access-by-id'
import blockTherapistAccessById from './clinic/block-therapist-access-by-id'
import checkConfiguration from './clinic/check-configuration'
import checkConfigurationPublications from './clinic/check-configuration-publications'
import checkConfigurationPublicationsCategories from './clinic/check-configuration-publications-categories'
import createAdmin from './clinic/create-admin'
import deleteAdminById from './clinic/delete-admin-by-id'
import deleteClinicChecklist from './clinic/delete-clinic-checklist'
import deleteClinicTask from './clinic/delete-clinic-task'
import deleteOperatorById from './clinic/delete-operator-by-id'
import deletePatientById from './clinic/delete-patient-by-id'
import deleteResponsibleById from './clinic/delete-responsible-by-id'
import deleteTherapistById from './clinic/delete-therapist-by-id'
import editAdmin from './clinic/edit-admin'
import { editTaskTag } from './clinic/edit-task-tag'
import getAdmins from './clinic/get-admins'
import getClinicChecklists from './clinic/get-clinic-checklists'
import getClinicTasks from './clinic/get-clinic-tasks'
import getConfigurationPublications from './clinic/get-configurationPublications'
import getConfigurations from './clinic/get-configurations'
import getResumedAccessProfiles from './clinic/get-resumed-access-profiles'
import getAllResponsibles from './clinic/getAllResponsibles'
import uncheckConfiguration from './clinic/uncheck-configuration'
import updateClinicTask from './clinic/update-clinic-task'
import updateConfigurations from './clinic/update-configurations'
import verifyCpf from './clinic/verifyCpf'
import getCompany from './company/get-company'
import getDriveEditableUrl from './doc/get-drive-editable-url'
import syncDriveFileInBucket from './doc/sync-drive-file-in-bucket'
import createPostCommentFeed from './feed/create-post-comment-feed'
import publishPost, { publishPostFromDrive } from './feed/create-post-feed'
import createReaction from './feed/create-reaction'
import deletePublication from './feed/delete-publication'
import deleteReaction from './feed/delete-reaction'
import fixPost from './feed/fix-post'
import getMyGroups from './feed/get_groups/get-my-groups'
import getPublishableGroups from './feed/get_groups/get-publishable-groups'
import getPublishableGroupsByPatient from './feed/get_groups/get-publishable-groups-by-patient'
import getActivitiesForAPerson from './feed/get-activities-for-a-person'
import getFriendships from './feed/get-friendships'
import getGroupFixedPosts from './feed/get-group-fixed-post'
import getPostById from './feed/get-post-by-id'
import getPostComments from './feed/get-post-comments'
import getUserFeed from './feed/get-user-feed'
import getUserFixedPost from './feed/get-user-fixed-post'
import {
  deletePostComment,
  editPost,
  editPostComment,
  getMyCommonGroupMembers,
  getMyCommonGroupMembersWithCurrentPerson
} from './feed/post-service'
import registerVisualization from './feed/register_visualization'
import sharePost from './feed/share-post'
import tagAsViewed from './feed/tag-as-viewed'
import unfixPost from './feed/unfix-post'
import createFolder from './gallery/create-folder'
import createFolderGroup from './gallery/create-folder-group'
import deletePersonaFolder from './gallery/delete-folder'
import deleteFolderAccess from './gallery/delete-folder-access'
import deleteShareFolderAccessProfile from './gallery/delete-folder-access-profile'
import deletePersonaFolderGroup from './gallery/delete-folder-group'
import deleteShareFolderGroupPermission from './gallery/delete-folder-permission'
import deleteGroupFile from './gallery/delete-group-file'
import deletePersonaFile from './gallery/delete-persona-file'
import deleteShareFolder from './gallery/delete-share-folder'
import getFolderFiles from './gallery/get-folder-files'
import getFolderFilesAndFolders from './gallery/get-folder-files-and-subfolders'
import getFolderFilesGroup from './gallery/get-folder-files-group'
import getFolderShareOptions from './gallery/get-folder-share-options'
import getGroupFolders from './gallery/get-group-folders'
import getPermissionsFolderAccessProfile from './gallery/get-permissions-access-profile'
import getPermissionsDrive from './gallery/get-permissions-drive'
import getPersonaFiles from './gallery/get-persona-files'
import getPersonaFolders from './gallery/get-persona-folders'
import updateFolderGroup from './gallery/move-folder'
import moveGroupFiles from './gallery/move-group-files'
import movePersonaFiles from './gallery/move-persona-files'
import updateFileNameGroup from './gallery/rename-drive-group'
import updateFileName from './gallery/rename-persona-file'
import shareFolder from './gallery/share-folder'
import shareFolderAccess from './gallery/share-folder-access'
import shareFolderGroup from './gallery/share-folder-group'
import shareFolderGroupPermission from './gallery/share-folder-group-permission'
import updateFolder from './gallery/update-folder'
import updateFolderGroupVisibility from './gallery/update-folder-group'
import uploadFiles from './gallery/upload-files'
import uploadFilesGroup from './gallery/upload-files-group'
import acceptInvite from './group/accept-invite'
import addPatientToGroup from './group/add-patient-to-group'
import createGroup from './group/create-group'
import getGroupFeed from './group/get-group-feed'
import getGroupInfo from './group/get-group-infos'
import getGroupMembers from './group/get-group-members'
import getGroupMembershipRequests from './group/get-group-membership-requests'
import getGroupNotMembers from './group/get-group-not-members'
import getPersonaGroupsStatus from './group/get-persona-groups-status'
import getPersonaInvitations from './group/get-persona-invitations'
import invitePersonaToGroup from './group/invite-persona'
import lastActivity from './group/last-activity'
import lastActivityArchived from './group/last-activity-archived'
import lastActivityPatientId from './group/last-activity-patientId'
import registerVisualizationGroup from './group/register_visualization-group'
import removePatientOfGroup from './group/remove-patient-of-group'
import replyMembershipRequest from './group/reply-membership-request'
import requestToJoinGroup from './group/request-to-join-group'
import updateGroupInfos from './group/update-group-infos'
import updateGroupOptions from './group/update-group-options'
import updateMemberStatus from './group/update-member-status'
import deleteManualGroupAutomation from './listGroupsFeed/deleteManualGroupAutomation'
import createOperators from './operators/create-operators'
import getClinicOperators from './operators/get-clinic-operators'
import getOperationalById from './operators/get-operator-by-id'
import updateOperationalById from './operators/update-operational-by-id'
import assignResponsible from './patients/assign-responsible'
import createClient from './patients/create-client'
import editPatientDetails from './patients/edit-patient-details'
import getClinicPatients from './patients/get-clinic-patients'
import getPatientDetails from './patients/get-patient-details'
import therapistInfo from './patients/therapist-info'
import unbindResponsible from './patients/unbind-responsible'
import unbindTherapist from './patients/unbind-therapist'
import updatePatient from './patients/update-patient'
import getGroupsByCategory from './permissions-toogle/get-groups-by-category'
import getPermissionsGroup from './permissions-toogle/get-permissions'
import getPermissionManual from './permissions-toogle/getPermissionManual'
import updatePermissionAutomatic from './permissions-toogle/updatePermissionAutomatic'
import updatePermissionGroup from './permissions-toogle/updatePermissionGroup'
import updatePermissionManual from './permissions-toogle/updatePermissionManual'
import updatePermissionTherapist from './permissions-toogle/updatePermissionTherapist'
import updateVisibilityPermissionAutomatic from './permissions-toogle/updateVisibilityPermissionAutomatic'
import updateVisibilityPermissionGroupManual from './permissions-toogle/updateVisibilityPermissionManual'
import getPersonaProfile from './profile/get-persona-profile'
import updatePersonaProfile from './profile/update-persona-profile'
import updateInfoResponsible from './responsible/update-info-responsible'
import { createEventSchedule } from './schedule/create-event-schedule'
import { declarePatientAbsence } from './schedule/declare-patient-absence'
import { getSpecialties } from './schedule/get-specialties'
import { getTherapistForSpecialty } from './schedule/get-therapist-for-specialty'
import { specialtyForTherapist } from './schedule/specialty-for-therapist'
import addChecklistItem from './tasks/add-checklist-item'
import addFileToTask from './tasks/add-file-to-task'
import addMembers from './tasks/add-members'
import createChecklist from './tasks/create-checklist'
import { createTask } from './tasks/create-task'
import { createTaskComment } from './tasks/create-task-comment'
import { createTaskTag } from './tasks/create-task-tag'
import deleteAssignedTaskMembers from './tasks/delete-asigned-task-member'
import deleteChecklist from './tasks/delete-checklist'
import deleteChecklistItem from './tasks/delete-checklist-item'
import { deleteTaskById } from './tasks/delete-task'
import { deleteTaskComment } from './tasks/delete-task-comment'
import deleteTaskFile from './tasks/delete-task-file'
import { desativateTags } from './tasks/desativate-tags'
import { editTask } from './tasks/edit-task'
import { editTaskComment } from './tasks/edit-task-comment'
import { editTaskStatus } from './tasks/edit-task-status'
import createChecklistModel from './tasks/favorite-checklist/create-cheklist-model'
import deleteChecklistModel from './tasks/favorite-checklist/delete-checklist-model'
import getFavoriteChecklists from './tasks/favorite-checklist/get-favorite-checklists'
import createFavoriteTask from './tasks/favorite-tasks/create-favorite-task'
import deleteTaskModel from './tasks/favorite-tasks/delete-task-model'
import {
  default as getFavoriteTask,
  default as getFavoriteTasks
} from './tasks/favorite-tasks/get-favorite-task'
import { getAllTaskTags } from './tasks/get-all-task-tags'
import getTaskById from './tasks/get-task-by-id'
import { getTaskByMemberId } from './tasks/get-task-by-member-id'
import { getTaskTagsByIds } from './tasks/get-task-tags-by-ids'
import {
  default as getAllTasksByMemberIdWithTaskResponse,
  default as getTasksByMemberId
} from './tasks/get-tasks-by-member-id'
import { getTasksInfo } from './tasks/get-tasks-info'
import getUserTasks from './tasks/get-user-tasks'
import viewTaskUser from './tasks/how-view-task'
import updateChecklistItem from './tasks/update-checklist-item'
import updateTaskTags from './tasks/update-task-tags'
import { createTemplatesFolder } from './templatesArquive/create-template'
import { deleteTemplate } from './templatesArquive/delete-template'
import { getTemplatesFolder } from './templatesArquive/get-templates'
import {
  deletePermissionTemplateGallery,
  updatePermissionTemplateGallery
} from './templatesArquive/permissions-templates'
import { renameTemplatesFolder } from './templatesArquive/rename-templates'
import createTherapist from './therapists/create-therapist'
import createTherapistManager from './therapists/create-therapist-manager'
import getClinicTherapists from './therapists/get-clinic-therapists'
import getTherapistById from './therapists/get-therapist-by-id'
import therapistPendingInvite from './therapists/pending-therapist'
import removeInviteTherapists from './therapists/remove-invite-therapists'
import sendInviteTherapists from './therapists/send-invite-therapists'
import updateTherapistById from './therapists/update-therapist-by-id'
import changePasswordWithSecretCode from './users/forgot-my-password/change-password-with-secret-code'
import sendEmailCode from './users/forgot-my-password/send-email-code'
import verifyCode from './users/forgot-my-password/verify-code'
import getAllPersonas from './users/get-all-personas'
import getAllUsers from './users/get-all-users'
import getUserByCpf from './users/get-by-cpf'
import getPersonasById from './users/get-personas-by-id'
import login from './users/login'

const Api = {
  acceptInvite,
  addChecklistItem,
  addFileToTask,
  addMembers,
  addPatientToGroup,
  assignResponsible,
  belongConfig,
  blockOperatorAccessById,
  blockTherapistAccessById,
  bodyConfig,
  caaConfig,
  changeConfiguration: checkConfiguration,
  changePassword,
  changePasswordWithSecretCode,
  checkConfiguration,
  checkConfigurationPublications,
  checkConfigurationPublicationsCategories,
  createAccessProfile,
  createAdmin,
  createChecklist,
  createChecklistModel,
  createClient,
  createEventSchedule,
  createFavoriteTask,
  createFolder,
  createFolderGroup,
  createGroup,
  createMacroArea,
  createOperators,
  createPoint,
  createPostCommentFeed,
  createReaction,
  createTask,
  createTaskComment,
  createTaskTag,
  createTemplatesFolder,
  createTherapist,
  createTherapistManager,
  declarePatientAbsence,
  deleteAdminById,
  deleteAssignedTaskMembers,
  deleteChecklist,
  deleteChecklistItem,
  deleteChecklistModel,
  deleteClinicChecklist,
  deleteClinicTask,
  deleteFolderAccess,
  deleteGroupFile,
  deleteGroupUser,
  deleteMacroArea,
  deleteManualGroupAutomation,
  deleteOperatorById,
  deletePatientById,
  deletePermissionTemplateGallery,
  deletePersonaFile,
  deletePersonaFolder,
  deletePersonaFolderGroup,
  deletePoint,
  deletePostComment,
  deletePublication,
  deleteReaction,
  deleteResponsibleById,
  deleteShareFolder,
  deleteShareFolderAccessProfile,
  deleteShareFolderGroupPermission,
  deleteTaskById,
  deleteTaskComment,
  deleteTaskFile,
  deleteTaskModel,
  deleteTemplate,
  deleteTherapistById,
  desativateTags,
  editAdmin,
  editPatientDetails,
  editPost,
  editPostComment,
  editTask,
  editTaskComment,
  editTaskStatus,
  editTaskTag,
  fixPost,
  getActivitiesForAPerson,
  getAdmins,
  getAllPersonas,
  getAllResponsibles,
  getAllTasksByMemberIdWithTaskResponse,
  getAllTaskTags,
  getAllUsers,
  getBelongConfig,
  getBodyConfig,
  getCAAConfig,
  getClinicChecklists,
  getClinicOperators,
  getClinicPatients,
  getClinicTasks,
  getClinicTherapists,
  getCompany,
  getConfigurationPublications,
  getConfigurations,
  getDriveEditableUrl,
  getFavoriteChecklists,
  getFavoriteTask,
  getFavoriteTasks,
  getFolderFiles,
  getFolderFilesAndFolders,
  getFolderFilesGroup,
  getFolderShareOptions,
  getFriendships,
  getGroupFeed,
  getGroupFixedPosts,
  getGroupFolders,
  getGroupInfo,
  getGroupMembers,
  getGroupMembershipRequests,
  getGroupNotMembers,
  getGroupsByCategory,
  getGroupUsersDetails,
  getMacroAreas,
  getMyCommonGroupMembers,
  getMyCommonGroupMembersWithCurrentPerson,
  getMyGroups,
  getOperationalById,
  getPatientDetails,
  getPermissionManual,
  getPermissionsDrive,
  getPermissionsFolderAccessProfile,
  getPermissionsGroup,
  getPersonaFiles,
  getPersonaFolders,
  getPersonaGroupsStatus,
  getPersonaInvitations,
  getPersonaProfile,
  getPersonasById,
  getPoints,
  getPostById,
  getPostComments,
  getPublishableGroups,
  getPublishableGroupsByPatient,
  getResumedAccessProfiles,
  getSpecialties,
  getTaskById,
  getTaskByMemberId,
  getTasksByMemberId,
  getTasksInfo,
  getTaskTagsByIds,
  getTemplatesFolder,
  getTherapistById,
  getTherapistForSpecialty,
  getUserByCpf,
  getUserFeed,
  getUserFixedPost,
  getUserTasks,
  invitePersonaToGroup,
  lastActivity,
  lastActivityArchived,
  lastActivityPatientId,
  listGroupUserProfiles,
  listGroupUsers,
  listGroupUsersByFeedGroup,
  listManagerGroupUsers,
  listNonAdminGroupUsers,
  login,
  moveGroupFiles,
  movePersonaFiles,
  publishPost,
  publishPostFromDrive,
  registerVisualization,
  registerVisualizationGroup,
  removeInviteTherapists,
  removePatientOfGroup,
  renameTemplatesFolder,
  replyMembershipRequest,
  requestToJoinGroup,
  sendEmailCode,
  sendInviteTherapists,
  shareFolder,
  shareFolderAccess,
  shareFolderGroup,
  shareFolderGroupPermission,
  sharePost,
  specialtyForTherapist,
  syncDriveFileInBucket,
  tagAsViewed,
  therapistInfo,
  therapistPendingInvite,
  unbindResponsible,
  unbindTherapist,
  uncheckConfiguration,
  unfixPost,
  updateChecklistItem,
  updateClinicTask,
  updateConfigurations,
  updateFileName,
  updateFileNameGroup,
  updateFolder,
  updateFolderGroup,
  updateFolderGroupVisibility,
  updateGroupInfos,
  updateGroupOptions,
  updateGroupPermissions,
  updateGroupUsersName,
  updateInfoResponsible,
  updateMacroArea,
  updateMemberStatus,
  updateOperationalById,
  updatePatient,
  updatePermissionAutomatic,
  updatePermissionGroup,
  updatePermissionManual,
  updatePermissionTemplateGallery,
  updatePermissionTherapist,
  updatePersonaProfile,
  updatePoint,
  updateTaskTags,
  updateTherapistById,
  updateVisibilityPermissionAutomatic,
  updateVisibilityPermissionGroupManual,
  uploadFiles,
  uploadFilesGroup,
  verifyCode,
  verifyCpf,
  viewTaskUser
}

export { default as axios } from '../../helpers/axios'
export type Response<T> = Promise<[AxiosResponse<T>, null] | [null, AxiosError]>
export default Api
